/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { License } from './License';
import {
    LicenseFromJSON,
    LicenseFromJSONTyped,
    LicenseToJSON,
    LicenseToJSONTyped,
} from './License';

/**
 * 
 * @export
 * @interface SubmissionRequestWithEmail
 */
export interface SubmissionRequestWithEmail {
    /**
     * 
     * @type {string}
     * @memberof SubmissionRequestWithEmail
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRequestWithEmail
     */
    protein: string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionRequestWithEmail
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRequestWithEmail
     */
    targetAA: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequestWithEmail
     */
    vinaJobDesiredRun?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequestWithEmail
     */
    reuseUnfinishedJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequestWithEmail
     */
    requireTemplateId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequestWithEmail
     */
    preventStart?: boolean;
    /**
     * 
     * @type {License}
     * @memberof SubmissionRequestWithEmail
     */
    license?: License;
}

/**
 * Check if a given object implements the SubmissionRequestWithEmail interface.
 */
export function instanceOfSubmissionRequestWithEmail(value: object): value is SubmissionRequestWithEmail {
    if (!('protein' in value) || value['protein'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('targetAA' in value) || value['targetAA'] === undefined) return false;
    return true;
}

export function SubmissionRequestWithEmailFromJSON(json: any): SubmissionRequestWithEmail {
    return SubmissionRequestWithEmailFromJSONTyped(json, false);
}

export function SubmissionRequestWithEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionRequestWithEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'protein': json['protein'],
        'position': json['position'],
        'targetAA': json['targetAA'],
        'vinaJobDesiredRun': json['vinaJobDesiredRun'] == null ? undefined : json['vinaJobDesiredRun'],
        'reuseUnfinishedJob': json['reuseUnfinishedJob'] == null ? undefined : json['reuseUnfinishedJob'],
        'requireTemplateId': json['requireTemplateId'] == null ? undefined : json['requireTemplateId'],
        'preventStart': json['preventStart'] == null ? undefined : json['preventStart'],
        'license': json['license'] == null ? undefined : LicenseFromJSON(json['license']),
    };
}

export function SubmissionRequestWithEmailToJSON(json: any): SubmissionRequestWithEmail {
    return SubmissionRequestWithEmailToJSONTyped(json, false);
}

export function SubmissionRequestWithEmailToJSONTyped(value?: SubmissionRequestWithEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'protein': value['protein'],
        'position': value['position'],
        'targetAA': value['targetAA'],
        'vinaJobDesiredRun': value['vinaJobDesiredRun'],
        'reuseUnfinishedJob': value['reuseUnfinishedJob'],
        'requireTemplateId': value['requireTemplateId'],
        'preventStart': value['preventStart'],
        'license': LicenseToJSON(value['license']),
    };
}

